import { render } from "./actionButtons.vue?vue&type=template&id=156b6ac1&scoped=true"
import script from "./actionButtons.vue?vue&type=script&lang=js"
export * from "./actionButtons.vue?vue&type=script&lang=js"

import "./actionButtons.vue?vue&type=style&index=0&id=156b6ac1&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\FrankCastelijns\\bzx_status\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-156b6ac1"]])

export default __exports__